import { useEffect, useState } from 'react';

import App from './App';
import fetchJson from 'Utils/fetchJson';
import { globalTrackerAPIRoot } from 'Constants/locations';

const PageRoot = (props) => {
  const [globalStatistics, setGlobalStatistics] = useState(props.globalStatistics);
  const [vaccinationSummaryStatistics, setVaccinationSummaryStatistics] = useState(props.vaccinationSummaryStatistics);
  const [hasFetched, setHasFetched] = useState(false);

  const refetchData = async() => {
    const [
      globalStatistics,
      vaccinationSummaryStatistics,
    ] = await Promise.all([
      fetchJson(`${globalTrackerAPIRoot}/statistics.json`),
      fetchJson('https://graphics.thomsonreuters.com/data/2020/coronavirus/owid-covid-vaccinations/latest-perpop-data-all.json'),
    ]);

    setGlobalStatistics(globalStatistics);
    setVaccinationSummaryStatistics(vaccinationSummaryStatistics);
    setHasFetched(true);
  };

  useEffect(() => {
    refetchData();
  }, [props.globalStatistics]);

  return (
    <App {...{
      ...props,
      globalStatistics,
      vaccinationSummaryStatistics,
      hasFetched,
      publicPrefix: process.env.NODE_ENV === 'production' ? '' : '',
    }}
    />
  );
};

export default PageRoot;
